import { a as __assign } from './tslib.es6-01f7d394.js';
import { f as focusTrapReact, d as defaultFocusTrapOptions } from './focusTrap-77103721.js';
import React__default from 'react';

var WithFocusTrap = function (_a) {
    var trapFocus = _a.trapFocus, active = _a.active, children = _a.children;
    if (trapFocus) {
        return (React__default.createElement(focusTrapReact, { focusTrapOptions: __assign(__assign({}, defaultFocusTrapOptions), { allowOutsideClick: true }), active: active }, children));
    }
    return React__default.createElement(React__default.Fragment, null, children);
};

export { WithFocusTrap as W };
